import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { RequestContext } from "../../context/request.context";

const UpdateRow = ({ row, action }) => {
  const { request } = useContext(RequestContext);
  const [loading, setLoading] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(row?.product);
  const [newRow, setNewRow] = useState(row);
  const [price, setPrice] = useState(row?.price);
  const [amount, setAmount] = useState(row?.amount);
  const [priceType, setPriceType] = useState(row?.priceType);
  const [sum, setSum] = useState(row?.sum);
  useEffect(() => {
    setLoading(true);
    request(`/product/all?search=${search}`, "GET").then((data) => {
      setLoading(false);
      setAllProducts(data.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const returnPrice = (selectedProduct) => {
    if (selectedProduct?.priceList) {
      let priceIndex = selectedProduct.priceList.findIndex(
        (item) => item.priceType === row.priceType
      );
      priceIndex = priceIndex === -1 ? 0 : priceIndex;
      return selectedProduct.priceList[priceIndex].price;
    }
    return row.price;
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "1rem",
        gap: "1rem",
      }}
      component={"form"}
      onSubmit={(e) => {
        e.preventDefault();
        const json = {
          ...newRow,
          name: selectedProduct.name,
          price,
          sum,
          quantity: amount,
          priceType: priceType,
          productId: selectedProduct.id,
          isChanged: true,
        };
        action(json);
      }}
    >
      <Typography variant="h6">{row?.product?.name} ni yangilash</Typography>
      <Typography variant="caption" textAlign={"center"}>
        Boshqa tovarni tanlash uchun tovar kodini kiriting
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <img
          src={selectedProduct?.photos[0].small}
          alt={selectedProduct?.name}
          width="32px"
          height="32px"
        />
        <Autocomplete
          fullWidth
          size="small"
          loading={loading}
          loadingText="Qidirilmoqda..."
          options={allProducts}
          getOptionLabel={(option) => option.name}
          value={selectedProduct}
          onChange={(e, value) => {
            setSelectedProduct(value);
            setNewRow({ ...newRow, product: value });
            setPrice(returnPrice(value));
            setSum(returnPrice(value) * amount);
          }}
          renderInput={(params) => (
            <TextField
              required
              {...params}
              variant="standard"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          )}
        />
      </Box>
      <TextField
        fullWidth
        size="small"
        label="Narx"
        name="price"
        value={price}
        onChange={(e) => {
          setPrice(e.target.value);
          setNewRow({ ...newRow, price: e.target.value });
          setSum(e.target.value * amount);
        }}
      />
      <TextField
        fullWidth
        size="small"
        label="Soni"
        name="quantity"
        value={amount}
        onChange={(e) => {
          setAmount(e.target.value);
          setNewRow({ ...newRow, amount: e.target.value });
          setSum(e.target.value * price);
        }}
      />
      <FormControl fullWidth size="small">
        <InputLabel id="priceType">Narx turi</InputLabel>
        <Select
          labelId="priceType"
          fullWidth
          size="small"
          label="Narx turi"
          name="priceType"
          value={priceType}
          onChange={(e) => {
            setPriceType(e.target.value);
            setNewRow({ ...newRow, priceType: e.target.value });
          }}
        >
          <MenuItem value="---">- - -</MenuItem>
          <MenuItem value="retail">Ommaviy</MenuItem>
          <MenuItem value="wholesale">To'lash</MenuItem>
        </Select>
      </FormControl>
      <TextField
        fullWidth
        size="small"
        label="Umumiy narx"
        name="sum"
        value={sum}
        onChange={(e) => {
          setSum(e.target.value);
          setNewRow({ ...newRow, sum: e.target.value });
        }}
      />
      <Button fullWidth type="submit" variant="contained">
        Saqlash
      </Button>
    </Box>
  );
};

export default UpdateRow;
